export function calcularDiferencaEmAnos(dataInicial, dataFinal) {
  const dataInicialObj = new Date(dataInicial);
  const dataFinalObj = new Date(dataFinal);

  const diferencaEmMS = dataFinalObj - dataInicialObj;
  const umAnoEmMS = 1000 * 60 * 60 * 24 * 365.25; // Considerando ano bissexto

  const diferencaEmAnos = Math.floor(diferencaEmMS / umAnoEmMS);
  return diferencaEmAnos;
};